module.exports = __webpack_public_path__ + "img/pers-label-prestation.95a8febd.jpg";